<template>
  <div class="space-y-1">
    <p class="text-text-neutral-primary">Язык приложения</p>
    <FreeSegmentControl :active-id="appLocale.lib.getAppLocale()">
      <FreeSegment
        v-for="lang in languages"
        :id="lang"
        :key="lang"
        :name="lang"
        @onChange="onLanguageChange"
      >
        {{ lang }}
      </FreeSegment>
    </FreeSegmentControl>
  </div>
</template>

<script setup lang="ts">
  import { appLocale } from 'shared';
  import { FreeSegment, FreeSegmentControl } from 'freedom-shared';

  const emit = defineEmits<{ onChange: [language: appLocale.config.Locale] }>();
  const languages = Object.values(appLocale.config.locales);
  const onLanguageChange = (strLang: string) =>
    emit('onChange', strLang as appLocale.config.Locale);
</script>
